import React from 'react'
import { ImageChoiceCol, QuizAnswerIndicator } from '../../../theme'

const ROW_COUNT = 2
const COL_COUNT = 2

function ImageChoices(props) {
  const {
    value,
    onSelect,
    choices,
    correctIndex,
    neutralQuestion,
    confirmResult,
    parentScreen,
    selected,
    quesType,
    quesId,
    finalAttempt,
  } = props

  return (
    <>
      <div
        className="mt-4"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gridGap: '10px',
        }}
      >
        {choices.map((choice, index) => (
          <div>
            <div
              style={{
                textAlign: 'right',
                marginBottom: '-10px',
                marginRight: '-10px',
              }}
            >
              <QuizAnswerIndicator
                height={'20px'}
                width={'20px'}
                src={
                  quesType === 'worksheet' && !finalAttempt && value !== null
                    ? value === index && correctIndex === index
                      ? '/images/success.png'
                      : value === index && correctIndex !== index
                      ? '/images/cancel.png'
                      : ''
                    : !quesType || (finalAttempt && value !== null)
                    ? parentScreen
                      ? ''
                      : correctIndex === index && value !== null
                      ? '/images/success.png'
                      : correctIndex !== index && value === index
                      ? '/images/cancel.png'
                      : ''
                    : '/images/success.png'
                }
                visibility={
                  quesType === 'worksheet' && !finalAttempt && value !== null
                    ? value === index && correctIndex === index
                      ? 'visible'
                      : value === index && correctIndex !== index
                      ? 'visible'
                      : 'hidden'
                    : !quesType || (finalAttempt && value !== null)
                    ? parentScreen
                      ? 'hidden'
                      : correctIndex === index && value !== null
                      ? 'visible'
                      : correctIndex !== index && value === index
                      ? 'visible'
                      : 'hidden'
                    : 'hidden'
                }
              />
            </div>
            <ImageChoiceCol
              onClick={() =>
                value == null && !parentScreen
                  ? onSelect(index, quesId)
                  : parentScreen && value == null
                  ? onSelect(index, quesId)
                  : null
              }
              selectedAns={
                quesType === 'worksheet' && !finalAttempt && value !== null
                  ? value === index && correctIndex === index
                    ? '#39c979'
                    : value === index && correctIndex !== index
                    ? '#EBAEAF'
                    : ''
                  : parentScreen && value !== null
                  ? value == index
                    ? '#39c979'
                    : ''
                  : ''
              }
              correct={
                !quesType || finalAttempt
                  ? parentScreen
                    ? selected === index
                    : value !== null && correctIndex === index
                    ? 1
                    : 0
                  : 0
              }
              wrong={
                !quesType || finalAttempt
                  ? parentScreen
                    ? null
                    : value !== null &&
                      correctIndex !== index &&
                      value === index
                    ? true
                    : false
                  : 0
              }
            >
              <div>
                <img
                  style={{
                    height: '120px',
                    width: '90%',
                    // OObjectFit:'contain',
                    margin: '8px',
                    padding: '0px',
                    borderRadius: '4px',
                  }}
                  src={choice}
                />
              </div>
              {/* <img src={choice} onError={onerror=null,src='/images/child.png'} /> */}
              {/* <ImageChoiceCard key={choice} url={choice} /> */}
            </ImageChoiceCol>
          </div>
        ))}
      </div>
    </>
  )
}

export default ImageChoices
